module.exports = __webpack_public_path__ + "img/no-meeting-icon.00d45157.svg";